var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5905 6.55769H26.5523L24.2446 14.6346H10.8331M25.3984 19.25H11.5523L9.24457 4.25H5.78303M5.78303 10.0192H3.47534M6.93688 13.4808H3.47534M8.09073 16.9423H3.47534M12.7061 23.8654C12.7061 24.5027 12.1895 25.0192 11.5523 25.0192C10.915 25.0192 10.3984 24.5027 10.3984 23.8654C10.3984 23.2281 10.915 22.7115 11.5523 22.7115C12.1895 22.7115 12.7061 23.2281 12.7061 23.8654ZM25.3984 23.8654C25.3984 24.5027 24.8818 25.0192 24.2446 25.0192C23.6073 25.0192 23.0907 24.5027 23.0907 23.8654C23.0907 23.2281 23.6073 22.7115 24.2446 22.7115C24.8818 22.7115 25.3984 23.2281 25.3984 23.8654Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cartIcon.a6157b76a5c4dd1429050cac0323ea26.svg";
export { ForwardRef as ReactComponent };